import { render } from "./InstallApp.vue?vue&type=template&id=4e2c5ffc&scoped=true"
import script from "./InstallApp.vue?vue&type=script&lang=js"
export * from "./InstallApp.vue?vue&type=script&lang=js"

import "./InstallApp.vue?vue&type=style&index=0&id=4e2c5ffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2c5ffc"]])

export default __exports__